module.exports = __webpack_public_path__ + "static/media/cloud-showers.f6e0c953.svg";